import {useFluxStore} from 'client/framework';
import React from 'react';

import {Banner} from '@albert-io/atomic';
import sessionStore from 'client/Session/SessionStore';
import {useShallow} from 'zustand/react/shallow';

import {
  pendingTeacherGradingText as translatedPendingText,
  studentText as translatedStudentText,
  useQuestionTranslationStore
} from 'client/components/QuestionTypes/shared/TranslationSection';

import useFrqPendingTeacherGrading from './hooks/useFrqPendingTeacherGrading';

const studentText = 'Your response has been submitted and will be graded outside of Albert.';
const teacherText = 'Free response questions are automatically graded as correct.';
const pendingText =
  'Your response was submitted and is being graded by your teacher. Check back later to see your grade.';

interface Props {
  /** The question this submission answers, used to find the student's own guess. */
  questionId?: string;
}

export default function CompletenessBanner({questionId}: Props) {
  const isStudent = useFluxStore(sessionStore, (s) => s.isStudent());
  const isPendingTeacherGrading = useFrqPendingTeacherGrading(questionId);
  const {showTranslations} = useQuestionTranslationStore(
    useShallow((state) => ({
      showTranslations: state.showTranslations && state.translationSettings.question
    }))
  );

  if (isPendingTeacherGrading) {
    return (
      <div className='mb-x4'>
        <Banner data-testid='pending-teacher-grading-banner' type='info'>
          <Banner.Icon
            className='pr-x0! mr-x2 self-center'
            icon='arrows-rotate'
            iconStyle='regular'
          />
          {showTranslations ? translatedPendingText : pendingText}
        </Banner>
      </div>
    );
  }

  const bannerText =
    showTranslations && isStudent ? translatedStudentText : isStudent ? studentText : teacherText;

  return (
    <div className='mb-x4'>
      <Banner type='positive'>
        <Banner.Icon icon='check' />
        {bannerText}
      </Banner>
    </div>
  );
}
